import styled from '@emotion/styled';
import { Card, tokens } from '@hotjar/hotsauce';

export const StyledCard = styled(Card)`
  text-align: left;

  & {
    width: 364px;
  }

  & > header {
  }

  & .card-body {
    padding: 0;
  }
`;

export const InnerBody = styled.div`
  max-height: 436px;
  overflow-y: auto;
  padding: ${tokens.spacer.x3};
`;
